export const EMAIL_PROVIDER_DISALLOW_REGEX = /^(yahoo|outlook|apple|yandex|aol)\.[a-z]{2,}$/i;
